import {defineStore} from 'pinia';
import {ModuleDashboardData} from '../moduleConst';
import { BaseDictionaryStore } from '../baseDictionaryStore';
import dashboardDataApi from '@/apis/dashboard/dashboardDataApi';
const dashboardDataStore = new BaseDictionaryStore(dashboardDataApi);
export const useDashboardDataStore = defineStore(ModuleDashboardData, {
  state: () => ({
    ...dashboardDataStore.state,
    _config: {
      key: 'id',
      table: 'dashboard_data',
      moduleName: 'dữ liệu của dashboard',
    },
    moduleName: 'dashboardData',
  }),
  actions: {...dashboardDataStore.action},
  getters: {
    ...dashboardDataStore.getters,
  },
});
